import stbAPIGateway from '../../../../services/stbAPIGateway';

export const getHubTenantsList = async ({ rootGetters, commit }) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = stbAPIGateway(axios, process.env.API_URL);

  const response = await stbApi.getHubTenantsList();
  if (response.displayNames) {
    commit('setHubTenants', response.displayNames);
  }
  return response.displayNames;
};
